/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratOnepagerInfo,
    JsonStratOnepagerInfoFromJSON,
    JsonStratOnepagerInfoFromJSONTyped,
    JsonStratOnepagerInfoToJSON,
} from './JsonStratOnepagerInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonStratOnepagerInfo
 */
export interface ApiResultOfListOfJsonStratOnepagerInfo {
    /**
     * 
     * @type {Array<JsonStratOnepagerInfo>}
     * @memberof ApiResultOfListOfJsonStratOnepagerInfo
     */
    data?: Array<JsonStratOnepagerInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratOnepagerInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonStratOnepagerInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratOnepagerInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratOnepagerInfo
     */
    result?: ApiResultOfListOfJsonStratOnepagerInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonStratOnepagerInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonStratOnepagerInfoFromJSON(json: any): ApiResultOfListOfJsonStratOnepagerInfo {
    return ApiResultOfListOfJsonStratOnepagerInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonStratOnepagerInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonStratOnepagerInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonStratOnepagerInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonStratOnepagerInfoToJSON(value?: ApiResultOfListOfJsonStratOnepagerInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonStratOnepagerInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

